import {EventSource} from 'eventsource';

const useSSEStreamChat = () => {
  const startStream = ({chatId}) => {
    const fullUrl = `${window.localStorage.getItem("BaseURL")}/services/projectmanagement/api/ai-bot/chat/${chatId}`;
    const sseOptions = {
      fetch: (input, init) =>
        fetch(input, {
          ...init,
          method: 'POST',
          headers: {
            ...init.headers,
            Authorization: `Bearer ${window.localStorage.getItem("Token")}`,
          },
        }),
    }

    const eventSource = new EventSource(fullUrl, sseOptions);

    return {
      onMessage: (handler) => eventSource.onmessage = handler,
      onError: (handler) => eventSource.onerror = handler,
      close: () => eventSource.close() 
    };
  }

  return startStream;
}

export default useSSEStreamChat